import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

export const updateProjectScopedSchedules = api(async function updateProjectScopedSchedules({
    projectId,
    scopedScheduleIds,
}) {
    return mutate(
        gql`
            mutation UpdateProjectScopedSchedules($projectId: String!, $scopedScheduleIds: [String!]!) {
                updateProjectScopedSchedules(projectId: $projectId, scopedScheduleIds: $scopedScheduleIds)
            }
        `,
        {
            projectId,
            scopedScheduleIds,
        },
        { returns: "updateProjectScopedSchedules" }
    )
})
